import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Stack,
  Box,
  Chip,
  IconButton,
  CircularProgress,
} from '@mui/material';
import { X, Share2, ArrowRight } from 'lucide-react';

import { rabbitmqApi } from '../../../../services/rabbitmqServices/rabbitmqService';

export const BindingsModal = ({
  isOpen = false,
  onClose = () => {},
  queueName = '',
  vhost = '/',
}) => {
  const [bindings, setBindings] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setLoading(true);
      rabbitmqApi.getBindings(vhost, queueName)
        .then((data) => setBindings(Array.isArray(data) ? data : []))
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
    }
  }, [isOpen, vhost, queueName]);

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Share2 style={{ width: 22, height: 22, color: '#7c3aed' }} />
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
              Exchange Bindings ({queueName})
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              Exchanges that route messages into this queue
            </Typography>
          </Box>
        </Stack>
        <IconButton size="small" onClick={onClose}>
          <X style={{ width: 18, height: 18 }} />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 3, maxHeight: '60vh', overflowY: 'auto' }}>
        {loading ? (
          <Box sx={{ py: 6, textAlign: 'center' }}>
            <CircularProgress size={28} sx={{ color: '#7c3aed', mb: 1 }} />
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Loading bindings...
            </Typography>
          </Box>
        ) : bindings.length === 0 ? (
          <Box sx={{ py: 6, textAlign: 'center' }}>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              No bindings found.
            </Typography>
          </Box>
        ) : (
          <Stack spacing={1.5}>
            {bindings.map((b, idx) => (
              <Box
                key={idx}
                sx={{
                  p: 2,
                  borderRadius: 2,
                  border: '1px solid',
                  borderColor: 'divider',
                  bgcolor: '#fff',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Stack direction="row" alignItems="center" spacing={1.5}>
                  <Chip
                    label={b.source ? b.source : '(Default Exchange)'}
                    size="small"
                    sx={{
                      fontWeight: 700,
                      bgcolor: 'rgba(0, 105, 81, 0.1)',
                      color: '#006951',
                    }}
                  />
                  <ArrowRight style={{ width: 14, height: 14, color: '#94a3b8' }} />
                  <Chip
                    label={b.destination}
                    size="small"
                    sx={{
                      fontWeight: 700,
                      bgcolor: 'rgba(2, 132, 199, 0.1)',
                      color: '#0284c7',
                    }}
                  />
                </Stack>

                <Box sx={{ textAlign: 'right' }}>
                  <Typography variant="caption" sx={{ textTransform: 'uppercase', color: 'text.secondary', display: 'block', fontSize: '0.65rem' }}>
                    Routing Key
                  </Typography>
                  <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: 700 }}>
                    {b.routing_key || '(blank)'}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );
};
